module.exports = __webpack_public_path__ + "static/media/text_black.17a61dc0.svg";